import { toast, type ToastOptions } from "react-hot-toast";
import Snackbar from "./Snackbar";
import type { SnackbarProps } from "./SnackbarProps";

export function showCustomToast(
  snackbarOptions?: SnackbarProps,
  options?: ToastOptions,
): void {
  toast.custom(
    (t) => (
      <Snackbar
        {...snackbarOptions}
        message={snackbarOptions?.message ?? ""}
        visible={t.visible}
        onClose={() => {
          toast.dismiss(t.id);
        }}
      />
    ),
    options,
  );
}
